'use client';

import Pagination from '@mui/material/Pagination';
import { FC } from 'react';
import { useRouter } from 'modules/i18n/navigation';
import styles from './styles.module.css';

export const ManualPagination: FC<{ count: number; page: number }> = ({
  count,
  page,
}) => {
  const router = useRouter();

  return (
    <Pagination
      className={styles.pagination}
      count={count}
      page={page}
      onChange={(_, page) => {
        router.push(`?page=${page}`);
      }}
    />
  );
};
